// ── 계약완료 상세 섹션 컴포넌트 ──────────────────────────────────────────────
// ResultModal 내에서 is_contracted=true 일 때만 렌더
// - 계약일자 입력
// - 상품 멀티선택 칩
// - 상품별 수량 + 유효기간 입력 (유효기간 있는 상품만)

import React from 'react';
import { TXT } from '../../../components/meetingmap/utils';
import {
  contractExpandedStyle, modalSectionLabelStyle, modalInputStyle,
  contractProductChipsStyle, contractProductChipStyle,
} from '../../../components/meetingmap/styles';

export function ContractSection({
  resultForm,
  setResultForm,
  contractTicketTypes,  // DB에서 조회한 상품 목록
  hasValiditySetting,   // (name) => bool — 유효기간 입력 UI 표시 여부
}) {
  return (
    <div style={contractExpandedStyle}>

      {/* ── 계약일자 ──────────────────────────────────────────── */}
      <div style={modalSectionLabelStyle}>{TXT.contractDate}</div>
      <div style={{ maxWidth: 180 }}>
        <input
          type="date"
          style={modalInputStyle}
          value={resultForm.contract_date}
          onChange={(e) =>
            setResultForm((prev) => ({ ...prev, contract_date: e.target.value }))
          }
        />
      </div>

      {/* ── 상품 멀티선택 칩 ──────────────────────────────────── */}
      {contractTicketTypes.length > 0 && (
        <>
          <div style={modalSectionLabelStyle}>상품 선택</div>
          <div style={contractProductChipsStyle}>
            {contractTicketTypes.map((t) => {
              const name = t.name || t; // DB 객체 또는 문자열 모두 호환
              const isSelected = (resultForm.selectedProducts || []).includes(name);
              return (
                <button
                  key={name}
                  type="button"
                  style={contractProductChipStyle(isSelected)}
                  onClick={() =>
                    setResultForm((prev) => {
                      const prevSel = prev.selectedProducts || [];
                      const newSel = isSelected
                        ? prevSel.filter((n) => n !== name)
                        : [...prevSel, name];
                      // 새로 선택 시: default_validity_months를 초기 유효기간으로 설정
                      const prevVal = prev.productValidities || {};
                      if (isSelected || prevVal[name]) return { ...prev, selectedProducts: newSel };
                      const product = contractTicketTypes.find((tt) => tt.name === name);
                      const defV = product?.default_validity_months != null
                        ? String(product.default_validity_months) : null;
                      const nextVal = defV ? { ...prevVal, [name]: defV } : prevVal;
                      return { ...prev, selectedProducts: newSel, productValidities: nextVal };
                    })
                  }
                >
                  {name}
                </button>
              );
            })}
          </div>
        </>
      )}

      {/* ── 상품별 수량 + 유효기간 입력 ──────────────────────── */}
      {(resultForm.selectedProducts || []).length > 0 ? (
        (resultForm.selectedProducts).map((name) => {
          // 유효기간 있는 상품 (영화티켓/제주 계열): 수량 + 유효기간 입력
          if (hasValiditySetting(name)) {
            return (
              <div key={name} style={{ display: 'grid', gap: 6 }}>
                <div style={modalSectionLabelStyle}>{name} — 수량</div>
                <input
                  type="text" inputMode="numeric" pattern="[0-9]*"
                  style={modalInputStyle} placeholder="장수 입력"
                  value={(resultForm.productCounts || {})[name] || ''}
                  onChange={(e) => setResultForm((prev) => ({
                    ...prev,
                    productCounts: { ...(prev.productCounts || {}), [name]: e.target.value.replace(/[^0-9]/g, '') },
                  }))}
                />
                {/* 유효기간: default_validity_months 기반 초기값, 직접 수정 가능 */}
                <div style={modalSectionLabelStyle}>유효기간</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <input
                    type="text" inputMode="numeric" pattern="[0-9]*"
                    style={{ ...modalInputStyle, width: 80 }}
                    value={(resultForm.productValidities || {})[name] || ''}
                    onChange={(e) => setResultForm((prev) => ({
                      ...prev,
                      productValidities: { ...(prev.productValidities || {}), [name]: e.target.value.replace(/[^0-9]/g, '') },
                    }))}
                  />
                  <span style={{ fontSize: 13, color: 'var(--text-sub)' }}>개월</span>
                </div>
              </div>
            );
          }
          // 일반 상품: 수량만 입력
          return (
            <div key={name} style={{ display: 'grid', gap: 5 }}>
              <div style={modalSectionLabelStyle}>{name} — 수량</div>
              <input
                type="text" inputMode="numeric" pattern="[0-9]*"
                style={modalInputStyle} placeholder="장수 입력"
                value={(resultForm.productCounts || {})[name] || ''}
                onChange={(e) =>
                  setResultForm((prev) => ({
                    ...prev,
                    productCounts: { ...(prev.productCounts || {}), [name]: e.target.value.replace(/[^0-9]/g, '') },
                  }))
                }
              />
            </div>
          );
        })
      ) : (
        // 상품 칩 미선택 시: 단일 장수 입력 (legacy fallback)
        <div style={{ display: 'grid', gap: 5 }}>
          <div style={modalSectionLabelStyle}>{TXT.ticketCount}</div>
          <input
            type="text" inputMode="numeric" pattern="[0-9]*"
            style={modalInputStyle} placeholder="장수 입력"
            value={resultForm.ticket_count}
            onChange={(e) =>
              setResultForm((prev) => ({
                ...prev,
                ticket_count: e.target.value.replace(/[^0-9]/g, ''),
              }))
            }
          />
        </div>
      )}
    </div>
  );
}
